export default __webpack_public_path__ + "static/celaya-labelbadge-06-2dd2a6899ec0eb8c53faf2650fcc0f20.png";